/* eslint-disable import/prefer-default-export */
export const WORDS_SINGULAR_PLURAL_MAPPING = {
  admin: "admins",
  item: "items",
  product: "products",
  recipient: "recipients",
  gift: "gifts",
  currency: "currencies",
  other: "others",
  category: "categories",
  message: "messages",
  result: "results",
  this: "these",
  is: "are",
  size: "sizes",
  color: "colors",
  has: "have",
  day: "days",
  email: "emails",
  shipment: "shipments",
  user: "users",
  contact: "contacts",
  campaign: "campaigns",
  automation: "automations",
  type: "types",
  was: "were",
  mention: "mentions",
  order: "orders",
  program: "programs",
  comment: "comments",
  hour: "hours",
  minute: "minutes",
  shop: "shops",
  country: "countries",
  seat: "seats",
  option: "options",
  design: "designs",
  member: "members",
  sender: "senders",
  wallet: "wallets",
};
